<template>
  <base-nav
    v-model="showMenu"
    class="navbar-absolute top-navbar"
    type="white"
    :transparent="true"
  >
    <div slot="brand" class="navbar-wrapper">
      <div class="navbar-minimize d-inline">
        <sidebar-toggle-button/>
      </div>
      <div
        class="navbar-toggle d-inline"
        :class="{ toggled: $sidebar.showSidebar }"
      >
        <button type="button" class="navbar-toggler" @click="toggleSidebar">
          <span class="navbar-toggler-bar bar1"></span> <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      <a class="navbar-brand" href="#">{{ routeName }}</a>
    </div>

    <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
      <li class="nav-item">
        <div class="locale-switch-container">
          <locale-switch></locale-switch>
        </div>
      </li>
      <base-dropdown
        tag="li"
        :menu-on-right="!$rtl.isRTL"
        title-tag="a"
        class="nav-item"
        title-classes="nav-link"
        menu-classes="dropdown-navbar"
      >
        <template
          slot="title"
        >
          <div class="photo"><img src="/img/default-avatar.png"/></div>
          <span class="ml-1 logged-user">{{ loggedUser.name }}</span>
          <b class="caret logged-user-caret d-none d-lg-block d-xl-block"></b>
          <p class="d-lg-none">Log out</p>
        </template>
        <li class="nav-link">
          <router-link to="/user/profile" class="nav-item dropdown-item">{{$t('page_user.profile')}}</router-link>
        </li>
        <li class="nav-link">
          <router-link to="/user/change-password" class="nav-item dropdown-item">{{$t('page_user.change_password')}}</router-link>
        </li>
        <div class="dropdown-divider"></div>
        <li class="nav-link">
          <router-link to="/user/logout" class="nav-item dropdown-item">{{$t('page_user.logout')}}</router-link>
        </li>
      </base-dropdown>
    </ul>
  </base-nav>
</template>
<script>
  import {CollapseTransition} from 'vue2-transitions';
  import {BaseNav, Modal} from '@/components';
  import SidebarToggleButton from './SidebarToggleButton';
  import LocaleSwitch from "@/components/LocaleSwitch";

  export default {
    components: {
      SidebarToggleButton,
      CollapseTransition,
      BaseNav,
      Modal,
      LocaleSwitch
    },
    computed: {
      loggedUser() {
        return this.$store.getters['Auth/loggedUser'];
      },
      routeName() {
        const {name} = this.$route;
        return name;
        // return this.$t('sidebar.' + name.toLowerCase());
      },
      isRTL() {
        return this.$rtl.isRTL;
      }
    },
    data() {
      return {
        activeNotifications: false,
        showMenu: false,
        searchModalVisible: false,
        searchQuery: ''
      };
    },
    methods: {
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications;
      },
      closeDropDown() {
        this.activeNotifications = false;
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      toggleMenu() {
        this.showMenu = !this.showMenu;
      }
    },
    mounted() {

    }
  };
</script>
<style scoped>
  .navbar .caret {
    right: 0;
    left: auto;
  }

  .locale-switch-container {
    margin-top: 4px;
  }

  .top-navbar {
    top: 0px;
  }
</style>
